import React from "react";

/**
 * Flat, iterative render of the PDF outline. Avoids self-referencing JSX
 * (which trips the visual-edits babel plugin's recursion depth).
 */
export default function OutlineTree({ items, onSelect, theme }) {
  if (!items?.length) return null;

  // Depth-first flatten into [{ title, item, depth, key }]
  const flat = [];
  const stack = [];
  for (let i = items.length - 1; i >= 0; i--) stack.push({ node: items[i], depth: 0, path: `${i}` });
  while (stack.length) {
    const { node, depth, path } = stack.pop();
    flat.push({ title: node.title || "Untitled", item: node, depth, key: path });
    const kids = node.items || [];
    for (let i = kids.length - 1; i >= 0; i--) stack.push({ node: kids[i], depth: depth + 1, path: `${path}-${i}` });
  }

  return (
    <ul className="space-y-1">
      {flat.map((row, idx) => (
        <li key={row.key}>
          <button
            data-testid={`reader-outline-item-${row.depth}-${idx}`}
            onClick={() => onSelect(row.item)}
            className="text-left text-xs w-full hover:opacity-70 leading-snug py-0.5"
            style={{
              color: theme.ink,
              paddingLeft: `${row.depth * 12}px`,
              borderLeft: row.depth > 0 ? "1px solid rgba(0,0,0,0.08)" : "none",
              marginLeft: row.depth > 0 ? "6px" : 0,
            }}
          >
            {row.title}
          </button>
        </li>
      ))}
    </ul>
  );
}
